import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, ProtectedRoute } from "./context/AuthContext";
import { RealtimeProvider } from "./context/RealtimeContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Extensions from "./pages/Extensions";
import SIPTrunks from "./pages/SIPTrunks";
import RingGroups from "./pages/RingGroups";
import CallQueues from "./pages/CallQueues";
import OutboundRules from "./pages/OutboundRules";
import OfficeHours from "./pages/OfficeHours";
import CallLogs from "./pages/CallLogs";
import EventLog from "./pages/EventLog";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import VoiceChat from "./pages/VoiceChat";
import Profile from "./pages/Profile";
import Login from "./pages/Login";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RealtimeProvider>
            <Toaster richColors closeButton />
            <Routes>
              {/* Public route */}
              <Route path="/login" element={<Login />} />
              
              {/* Protected routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                {/* User accessible routes */}
                <Route index element={<Dashboard />} />
                <Route path="call-logs" element={<CallLogs />} />
                <Route path="profile" element={<Profile />} />
                
                {/* Admin only routes */}
                <Route path="extensions" element={
                  <ProtectedRoute adminOnly={true}>
                    <Extensions />
                  </ProtectedRoute>
                } />
                <Route path="voice-chat" element={
                  <ProtectedRoute adminOnly={true}>
                    <VoiceChat />
                  </ProtectedRoute>
                } />
                <Route path="sip-trunks" element={
                  <ProtectedRoute adminOnly={true}>
                    <SIPTrunks />
                  </ProtectedRoute>
                } />
                <Route path="ring-groups" element={
                  <ProtectedRoute adminOnly={true}>
                    <RingGroups />
                  </ProtectedRoute>
                } />
                <Route path="call-queues" element={
                  <ProtectedRoute adminOnly={true}>
                    <CallQueues />
                  </ProtectedRoute>
                } />
                <Route path="outbound-rules" element={
                  <ProtectedRoute adminOnly={true}>
                    <OutboundRules />
                  </ProtectedRoute>
                } />
                <Route path="office-hours" element={
                  <ProtectedRoute adminOnly={true}>
                    <OfficeHours />
                  </ProtectedRoute>
                } />
                <Route path="event-log" element={
                  <ProtectedRoute adminOnly={true}>
                    <EventLog />
                  </ProtectedRoute>
                } />
                <Route path="reports" element={
                  <ProtectedRoute adminOnly={true}>
                    <Reports />
                  </ProtectedRoute>
                } />
                <Route path="settings" element={
                  <ProtectedRoute adminOnly={true}>
                    <Settings />
                  </ProtectedRoute>
                } />
              </Route>
              
              {/* Catch all - redirect to login */}
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </RealtimeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
